module.exports = __webpack_public_path__ + "img/2.f586ef81.jpg";